/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem,
    DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSON,
    DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSONTyped,
    DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItemToJSON,
    DigitizingMelcoModelsCustomWarning,
    DigitizingMelcoModelsCustomWarningFromJSON,
    DigitizingMelcoModelsCustomWarningFromJSONTyped,
    DigitizingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem
 */
export interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem {
    /**
     * 
     * @type {Array<DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem
     */
    list: Array<DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem>;
    /**
     * 
     * @type {Array<DigitizingMelcoModelsCustomWarning>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem
     */
    warning_list?: Array<DigitizingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem
     */
    total: number;
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSON(json: any): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem {
    return DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItemToJSON(value?: DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


